import React from 'react'
import './nav.css'
import {AiFillHome} from 'react-icons/ai'
import {FaUser} from 'react-icons/fa'
import {GiBrain} from 'react-icons/gi'
import {FaBookOpen} from 'react-icons/fa'
import {MdEmail} from 'react-icons/md'
import { useState } from 'react'

export default function Nav() {
  const [activeNav, setActiveNav] = useState ('#');
  const handleClick = (link) => {
    setActiveNav(link);
  }

  return (
    <nav>
      <a href="#" className={activeNav === '#' ? 'active' : ''} onClick={() => handleClick('#')}><AiFillHome /></a>
      <a href="#about" className={activeNav === '#about' ? 'active' : ''} onClick={() => handleClick('#about')}><FaUser /></a>
      <a href="#skills" className={activeNav === '#skills' ? 'active' : ''} onClick={() => handleClick('#skills')}><GiBrain /></a>
      <a href="#projects" className={activeNav === '#projects' ? 'active' : ''} onClick={() => handleClick('#portfolio')}><FaBookOpen /></a>
      <a href="#contact" className={activeNav === '#contact' ? 'active' : ''} onClick={() => handleClick('#contact')}><MdEmail /></a>
    </nav>
  )
}